import { Button } from 'reactstrap';
import useModalState from '../../../hooks/useModalState';
import { PreQualificationResultLogAction } from '../models/preQualificationModel';
import TableModal, { RowItem } from '../../../components/modals/TableModal';
import {
  PreQualificationLoggerActionBadge,
  PreQualificationResultStatusBadge,
} from './PreQualificationStatusBadge';
import {
  PreQualificationResultLoggerAction,
  PreQualificationResultStatus,
} from '../enums/PreQualificationEnum';

interface Props {
  log_actions: PreQualificationResultLogAction[];
}

const PreQualificationDetailBankLogActionModal = ({ log_actions }: Props) => {
  const [showModal, toggleShowModal] = useModalState();
  if (!log_actions || log_actions.length === 0) return null;

  const rowsItems: RowItem[] = log_actions.map((action) => {
    return {
      rows: [
        <PreQualificationResultStatusBadge
          status={action.previous_status as PreQualificationResultStatus}
        />,
        <PreQualificationResultStatusBadge
          status={action.current_status as PreQualificationResultStatus}
        />,
        <PreQualificationLoggerActionBadge
          status={action.action as PreQualificationResultLoggerAction}
        />,

        action.logged_at.toLocaleString(),
        action.user || 'N/A',
      ],
    };
  });

  return (
    <>
      <Button size="sm" color="secondary" onClick={() => toggleShowModal()}>
        <i className="ni ni-collection" />
        <span>Historial de acciones</span>
      </Button>
      <TableModal
        cardHeader={[
          'Estado Anterior',
          'Estado Actual',
          'Acción',
          'Fecha',
          'Usuario',
        ]}
        rows={rowsItems}
        striped
        isOpen={showModal}
        onToggle={toggleShowModal}
        title="Historial de acciones"
        size="lg"
      />
    </>
  );
};

export default PreQualificationDetailBankLogActionModal;
